import { useIntl } from "react-intl";

export default function LibrarySavedAt({ value }) {
  const intl = useIntl();
  const date = value == null ? null : new Date(value);
  if (!date || Number.isNaN(date.getTime())) return "–";

  return (
    <time dateTime={date.toISOString()}>
      {intl.formatDate(date, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      })}
    </time>
  );
}
